import React, {Component, PropTypes} from 'react';
import TextField from 'material-ui/TextField';
import DataList from './DataList.jsx';
import Link from 'react-router/lib/Link';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import _ from 'underscore';
import Search from 'material-ui/svg-icons/action/search';
import Paper from 'material-ui/Paper';

class DataListAndSearch extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.search = _.debounce(this.search.bind(this), 300);
    }

    onChange(e) {
        this.search(e.target.value);
    }

    search(q) {
        this.props.onChangeInput(q);
    }
    render() {
        const linkStyle = {
            display: this.props.showAddButton === false ? 'none' : 'auto',
        };

        const addButtonStyle = {
            position:'fixed',
            bottom:20, right:15
        };
        const addLink = this.props.showAddButton !== false
        ? (
            <Link style={linkStyle} to={this.props.addButtonLink}>
                <FloatingActionButton style={addButtonStyle}>
                    <ContentAdd />
                </FloatingActionButton>
            </Link>
        )
        : null;

        return (
            <div style={this.props.style}>
                <Paper style={{padding: '2px 20px 10px 20px', margin: this.props.searchMargin}}>
                    <h2 className="center">{this.props.searchTitle}</h2>
                    <TextField
                    onChange={this.onChange} 
                    name="search"
                    hintText={<span><Search viewBox="0 3 24 24" style={{verticalAlign:'middle'}} />{this.props.inputPlaceHolder}</span>}
                    fullWidth={true}
                    underlineStyle={{borderColor:'#bbb'}}
                    />
                    <div style={{fontSize:13, fontStyle:'italic'}}>
                        Criterios: {this.props.criterios}
                    </div>
                </Paper>
                <DataList
                sendMail={this.props.sendMail}
                handleSend={this.props.handleSend}
                useCard={this.props.useCard}
                items={this.props.items}
                count={this.props.count}
                handleEdit={this.props.handleEdit}
                handleDelete={this.props.handleDelete}
                rightButtonUseThis={this.props.rightButtonUseThis}
                resourceName={this.props.resourceName}
                retencion={this.props.retencion}
                handleSelect={this.props.handleSelect}
                download={this.props.download}
                handleDownload={this.props.handleDownload} />
                {addLink}
            </div>
        );
    }
}

DataListAndSearch.propTypes = {
    items: PropTypes.array.isRequired,
    handleEdit: PropTypes.func,
    handleDelete: PropTypes.func,
    rightButtonUseThis: PropTypes.bool,
    addButtonLink: PropTypes.string,
    onChangeInput: PropTypes.func.isRequired,
    resourceName: PropTypes.string.isRequired,
    retencion: PropTypes.bool,
    showAddButton: PropTypes.bool.isRequired
};

export default DataListAndSearch;


/** WEBPACK FOOTER **
 ** ./app-react/components/DataListAndSearch.jsx
 **/